var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "scanClass" },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("collectionCenter.returnNote")))]),
            _c("el-input", {
              attrs: {
                placeholder: _vm.$t("collectionCenter.scanOrInputParcelNumber"),
                clearable: "",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.addReturnData($event)
                },
              },
              model: {
                value: _vm.returnNoteVal,
                callback: function ($$v) {
                  _vm.returnNoteVal = $$v
                },
                expression: "returnNoteVal",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "14px",
                    color: "#606266",
                    "margin-right": "20px",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("collectionCenter.scanned")) + "："
                  ),
                  _c("span", { staticStyle: { color: "#409eff" } }, [
                    _vm._v(_vm._s(_vm.tableData.length)),
                  ]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.toReturn },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.InitiateRejection")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": 600,
                "header-cell-style": {
                  background: "#ebebeb",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  prop: "ind",
                  align: "center",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.waybillNumber"),
                  prop: "waybillNumber",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ScanNumber"),
                  prop: "ScanNumber",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanner"),
                  prop: "person",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanTime"),
                  prop: "scanTime",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: _vm.$t("collectionCenter.deleteSure"),
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.del(scope.$index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  color: "red",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.Delete"))
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "returnDialogClass",
          attrs: {
            title: _vm.$t("collectionCenter.tips"),
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("collectionCenter.initiateReturnTotal")) +
                  "：" +
                  _vm._s(_vm.sumbitMsg.reverseTotal)
              ),
            ]),
            _c(
              "div",
              {
                staticStyle: { "margin-top": "20px", "margin-bottom": "20px" },
              },
              [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "50%" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.orderSuccessful")) +
                        "：" +
                        _vm._s(_vm.sumbitMsg.reverseSuccess)
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "50%" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.orderFailure")) +
                        "：" +
                        _vm._s(
                          _vm.sumbitMsg.reverseFailList
                            ? _vm.sumbitMsg.reverseFailList.length
                            : 0
                        )
                    ),
                  ]
                ),
              ]
            ),
            _vm.sumbitMsg.reverseFailList &&
            _vm.sumbitMsg.reverseFailList.length > 0
              ? _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.orderFailedOrder")) +
                          "："
                      ),
                    ]),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.sumbitMsg.reverseFailList,
                          "show-header": false,
                          "max-height": 500,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "ind",
                            label: _vm.$t("collectionCenter.ind"),
                            width: "60",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "waybillNumber",
                            label: _vm.$t("collectionCenter.order"),
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "failReason",
                            label: _vm.$t("collectionCenter.reason"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }